import store from '@/store/index.js';

export default err => {
	if (err && err.response) {
		console.error('Error handled by handle-error.', err);
		store.dispatch('app/setCurrentErrorAction', err);
		store.dispatch('app/setPageLoadingAction', false);
	}
};
